import React, { Component } from 'react';
import { connect } from "react-redux";
import PulseLoader from 'react-spinners/PulseLoader'

class TransactionsView extends Component {
    render() {
        if (this.props.numPending === 0) {
            return (
                <div></div>
            );
        } else {
            return (
                <div className="pending-transactions">
                  Syncing {this.props.numPending} items
                  <PulseLoader
                    sizeUnit={"px"}
                    size={8}
                    color={'#6200ff'}
                    loading={true}
                    />
                </div>
            );
        }
    }
}

const mapStateToProps = (state, props) => {
    return {
        numPending: state.transactions.pendingTransactions.length
   }
};

export default connect(mapStateToProps, null)(TransactionsView);
